import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ServerTokenService } from "../../services/server-token.service";

export type RuleState = "decline" | "review" | "na";

export interface FacilityState {
  facilityId: string;
  state: RuleState;
}

export interface RegionDecisionRule {
  clientCategoryName: string;
  facilityStates: FacilityState[];
}

export interface SaveRuleBody {
  logicCategory: "care" | "behavioral";
  clientCategoryName: string;
  facilityStates: FacilityState[];
}

/** Response when fetching both categories in one call */
export interface RegionDecisionRulesAll {
  care: RegionDecisionRule[];
  behavioral: RegionDecisionRule[];
}

@Injectable({
  providedIn: "root",
})
export class RegionDecisionRulesService {
  private readonly path = "snfs/regionDecisionRules";

  constructor(private server: ServerTokenService) {}

  /** Single request – server returns both care and behavioral */
  getRulesAll(): Observable<RegionDecisionRulesAll> {
    return this.server.getWithToken<RegionDecisionRulesAll>(this.path, {});
  }

  saveRule(body: SaveRuleBody): Observable<{ success: boolean }> {
    return this.server.postWithToken<{ success: boolean }>(this.path, body);
  }

  setAiDecisionLogicEnabled(enabled: boolean): Observable<{ enabled: boolean }> {
    return this.server.postWithToken<{ enabled: boolean }>(
      "snfs/admin/setAiDecisionLogicEnabled",
      { enabled },
    );
  }

}
